export default __webpack_public_path__ + "media/zurb/img/about/talent/talent-img3-983833b187ae50fdeda33163a36e269c.png";